import { $http, buildHeaders } from "./index";

//获取员工报送列表
export const employeedeclare_list = (params) => {
  return $http.get("/admin/EmployeeDeclare/index", { params });
};

//员工报送
export const employeedeclare_declare = (data) => {
  return $http.post(
    "/admin/EmployeeDeclare/declare",
    { id: data.join(",") },
    {
      headers: buildHeaders(3),
    }
  );
};

//报送作废
export const employeedeclare_cancel = (id) => {
  return $http.post(
    "/admin/EmployeeDeclare/cancel",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//停止报送
export const employeedeclare_stoptax = (data) => {
  return $http.post(
    "/admin/EmployeeDeclare/stopTax",
    { id: data.join(",") },
    {
      headers: buildHeaders(3),
    }
  );
};

//更新身份验证状态
export const employeedeclare_updatestatus = (id) => {
  return $http.post(
    "/admin/EmployeeDeclare/updateVerifyStatus",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//批量编辑
export const employeedeclare_edits = (data) => {
  return $http.post("/admin/EmployeeDeclare/editBatch", data, {
    headers: buildHeaders(3),
  });
};

//导出
export const employeedeclare_export = (params) => {
  return $http.get("/admin/EmployeeDeclare/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
